import TagColumnBase from "./TagColumnBase";
import { ColumnStore } from "@bryntum/schedulerpro";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { SETTING_TAB_WIDGET_KEYS } from "../../../other/constants/OtherKeys.jsx";

const storeKey = "clientTagValues";

class ClientTagsColumn extends TagColumnBase {
  static get $name() {
    return "ClientTagsColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnClientTag;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_tags";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.tag;
  }

  get tabName() {
    return SETTING_TAB_WIDGET_KEYS.clientTagsTab;
  }

  get swivuListTitle() {
    return "Client Tags";
  }

  get canMultiSelectSwivuList() {
    return true;
  }
}

class ClientCategoryColumn extends TagColumnBase {
  static get $name() {
    return "ClientCategoryColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnClientCategory;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_category";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.category;
  }

  get tabName() {
    return SETTING_TAB_WIDGET_KEYS.clientCategoryTab;
  }

  get swivuListTitle() {
    return "Client Category";
  }
}

class ClientStatusColumn extends TagColumnBase {
  static get $name() {
    return "ClientStatusColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnClientStatus;
  }

  static get defaults() {
    return this.defaultFilterableOptions;
  }

  get tagRecordKey() {
    return "_status";
  }

  get storeKey() {
    return storeKey;
  }

  get tagKey() {
    return TAGS_KEYS.status;
  }

  get tabName() {
    return SETTING_TAB_WIDGET_KEYS.clientStatusTab;
  }

  get swivuListTitle() {
    return "Client Status";
  }
}

ColumnStore.registerColumnType(ClientCategoryColumn);
ColumnStore.registerColumnType(ClientTagsColumn);
ColumnStore.registerColumnType(ClientStatusColumn);
